import { GetterTree } from 'vuex'
import ScheduleState from './states'
import { State } from '@/store/store'
import _ from 'lodash'

const getters: GetterTree<ScheduleState, State> = {
  headerLists: (state) => {
    return state.list.column
  },
  scheduleLists: (state) => {
    const data = state.list.result
    const result: Array<{
      value?: any,
    }> = []
    data.forEach((each) => {
      result.push({
        value: each,
      })
    })
    return result
  },
  itemLists: (state) => {
    return state.list.result
  },
  filterLists: (state) => {
    return state.list.defaultFilter
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.list.itemCount,
      page: state.list.page,
      pageCount: state.list.pageCount,
    }
    return paginationLists
  },
  userItemLists: (state) => {
    // console.log(state.listUser)
    const data = state.listUser.result
    const result: Array<{
      name?: string,
      _id?: string,
      user?: any,
    }> = []
    data.forEach((each) => {
      result.push({
        name: each.prefix + each.firstname + ' ' + each.lastname,
        _id: each._id,
        user: each,
      })
    })
    return result
  },
  scheduleByJob: (state)  => {
    return state.listByJob.result
  },
  scheduleByUserLists: (state) => {
    return state.listByUser
  },
  holidayLists: (state) => {
    return state.listHoliday
  },
  logJobLists: (state) => {
    return state.logJobList
  },
  logPatientLists: (state) => {
    return state.logPatientList
  },
}

export default getters
